import * as moment from 'moment';
import { RegisterItem } from '../decorators/snitem-factory-decorator';
import { CNItem } from './cnitem';

@RegisterItem()
export class CNHealthProblem extends CNItem {

    constructor(itemid: number = 0) {
        super(itemid);
        this.key = 'SNItem.CNItem.CNHealthProblem';
    }

    get date(): Date {
        if (this.getProperty('date')) {
            return moment(this.getProperty('date'), 'DD/MM/YYYY').toDate();
        }
        return this.createddate;
    }

    get startDate(): Date {
        if (this.getProperty('StartDate') && this.getProperty('StartDate').length !== 0) {
            return moment(this.getProperty('StartDate'), 'DD/MM/YYYY').toDate();
        }
        return undefined;
    }

    get endDate(): Date {
        if (this.getProperty('EndDate') && this.getProperty('EndDate').length !== 0) {
            return moment(this.getProperty('EndDate'), 'DD/MM/YYYY').toDate();
        }
        return undefined;
    }

    public clone(): any {
        return new CNHealthProblem();
    }
}
